module.exports = __webpack_public_path__ + "static/media/wipro_logo.a7811e2f.png";